import * as componentMap from './index';

export function installCoreComponents(Vue) {
  Object.keys(componentMap).forEach(key => {
    const component = componentMap[key];
    if (component.name !== undefined) {
      Vue.component(component.name, component);
    }
  });
}
